import clsx from 'clsx'

import { ChildProps } from '@/common/util/props'

import Text from '@/components/view/atoms/text/Text'

interface Props extends ChildProps {
  subText?: string
  subNode?: React.ReactNode
}

const SummaryHeading = ({ children, subText, subNode }: Props) => {
  return (
    <div className={clsx('px-4 py-2', subNode && 'flex items-center justify-between')}>
      {subText ? (
        <div className='flex flex-col gap-0.5'>
          <Text size={16} weight={'bold'} lineHeight={150} tag='h3' fullWidth>
            {children}
          </Text>
          <Text size={12} color='secondary' lineHeight={150}>
            {subText}
          </Text>
        </div>
      ) : (
        <Text size={16} weight={'bold'} lineHeight={150} tag='h3' fullWidth>
          {children}
        </Text>
      )}
      {subNode && <>{subNode}</>}
    </div>
  )
}

export default SummaryHeading
